package link.erpango.quip.domain.usecases

import link.erpango.quip.domain.entities.DExtractionError
import link.erpango.quip.domain.entities.DExtractionStatus
import link.erpango.quip.domain.noteimport.ImportDraft
import link.erpango.quip.domain.noteimport.NoteImportEvent

sealed interface NoteImportAiResult {
    data class Success(val draft: ImportDraft) : NoteImportAiResult
    data class Failure(val error: DExtractionError) : NoteImportAiResult
}

/**
 * "Importar desde nota": turns a pasted note into drafts for review. Nothing here creates
 * anything; the user confirms every item in a form or in the review screen.
 */
interface INoteImportUseCase {
    /** Offline parser only: instant, nothing leaves the device. */
    suspend fun analyzeLocally(note: String): ImportDraft

    /**
     * Sends the note to the backend LLM and merges the result into [local]. Callers must ask
     * for consent first ([hasAiConsent]); notes longer than
     * [link.erpango.quip.domain.noteimport.NoteImportLimits.MAX_NOTE_LENGTH] are rejected
     * without any request.
     */
    suspend fun improveWithAi(note: String, local: ImportDraft): NoteImportAiResult

    /** Availability and remaining quota; null when it could not be checked. */
    suspend fun aiStatus(): DExtractionStatus?

    suspend fun hasAiConsent(): Boolean

    suspend fun setAiConsent(granted: Boolean)

    fun track(event: NoteImportEvent)
}
